import { Box, Divider } from '@mantine/core';
import MarkdownEditor from 'src/common/components/markdown-editor/MarkdownEditor';
import { DownloadFileButton } from 'src/common/components/buttons/DownloadFileButton';

type Props = {
  markdownContent: string;
  fileId: number;
};

export const MeetingNoteContent = ({ markdownContent, fileId }: Props) => {
  return (
    <Box>
      <Divider color="gray.1" mt={'sm'} mb={'xxxs'} />
      <DownloadFileButton variant={'subtle'} fileId={fileId} c="brand.8" />
      <Divider color="gray.1" mb={'sm'} mt={'xxxs'} />
      <MarkdownEditor
        defaultValue={markdownContent}
        readonly={true}
        h="100%"
        withBorder={false}
        style={{ borderWidth: 0 }}
        bg="transparent"
        rootClass="compact"
        px="xs"
        py={0}
        mt="-lg"
      />
    </Box>
  );
};
